var e = "10.30.0+unknown";
//#endregion
export { e as REPORT_PACKAGE_VERSION };
